import React, { useState, useEffect, useRef } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { Magic } from 'magic-sdk'
import { OAuthExtension } from '@magic-ext/oauth'
import { Spinner } from 'baseui/spinner'
import { useRecoilValue } from 'recoil'
import { publicIsLoggedIn } from '@/store/onepager/onepager'
import axios from 'axios'
import Cookies from 'js-cookie'
import useCopyToClipboard from 'react-use/lib/useCopyToClipboard'
import { reactLocalStorage } from 'reactjs-localstorage'
import { useRouter } from 'next/router'

import { currentTemplateID } from '@/store/onepager/onepager'
function ShareModal({ collection, closeModal }) {
  const [shareUrl, setShareUrl] = useState('')
  const getCurrentTemplateId = useRecoilValue(currentTemplateID)
  const [clipboardState, copyToClipboard] = useCopyToClipboard()
  const [noSavedContent, setNoSavedContent] = useState(false)
  const [isLoading, setLoading] = useState(true)
  const router = useRouter()

  useEffect(async () => {
    // create url start
    let shareURLStart = ''
    const prod = process.env.NODE_ENV === 'production'

    let currentSlug = window.location.host.split('.')
    // use subdomain in url
    if (prod) {
      if (isPrettyURL()) {
        shareURLStart =
          'https://' +
          window.location.host +
          '/' +
          router.query.url +
          '?shareId='
      } else {
        shareURLStart =
          'https://' +
          window.location.host +
          '/?i=' +
          getUrlParameter('i') +
          '&shareId='
      }
    } else {
      if (isPrettyURL()) {
        shareURLStart =
          'http://' +
          window.location.host +
          '/' +
          router.query.url +
          '?shareId='
      } else {
        shareURLStart =
          'http://' +
          window.location.host +
          '/?i=' +
          getUrlParameter('i') +
          '&shareId='
      }
    }

    const getUserContent = await axios.post('/api/rest/get-user-content-id', {
      email: Cookies.get('wl-email'),
      templateId: getCurrentTemplateId,
    })

    if (getUserContent.data) {
      // console.log(getUserContent.data.contentId['@ref'].id)
      // url is created - get userContentID
      shareURLStart = shareURLStart + getUserContent.data.contentId['@ref'].id
      setShareUrl(shareURLStart)
      setLoading(false)
      setNoSavedContent(false)
    } else {
      // create first saved thing ?
      setLoading(false)
      setNoSavedContent(true)
    }
  }, [])

  function isPrettyURL() {
    var result = null,
      tmp = []
    location.search
      .substr(1)
      .split('&')
      .forEach(function (item) {
        tmp = item.split('=')
        if (tmp[0] === 'i') result = decodeURIComponent(tmp[1])
      })
    if (!result) {
      // if i is found - not pretty url page
      return true
    } else {
      return false
    }
  }

  function getUrlParameter(parameterName) {
    var result = null,
      tmp = []
    location.search
      .substr(1)
      .split('&')
      .forEach(function (item) {
        tmp = item.split('=')
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
      })

    if (parameterName == 'i') {
      // check if it its a [url] page
      if (result) {
        return result
      } else {
        let getURL = router.query.url
        getURL = getURL.split('-')
        getURL = getURL.pop()
        return getURL
      }
    } else {
      // shareID or something else
      return result
    }
  }

  return (
    <div className="fixed top-0 left-0 w-full h-full  z-50 flex flex-col justify-center items-center">
      <motion.div
        initial="hidden"
        animate="visible"
        exit="exit"
        transition={{ duration: 0.15 }}
        variants={{
          hidden: {
            opacity: 0,
          },
          visible: {
            opacity: 1,
          },
          exit: {
            opacity: 0,
          },
        }}
        onClick={() => {
          closeModal()
        }}
        className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-25 cursor-pointer"
      ></motion.div>
      <motion.div
        initial="hidden"
        animate="visible"
        exit="exit"
        transition={{ duration: 0.15 }}
        variants={{
          hidden: {
            opacity: 0,
            scale: 0.9,
          },
          visible: {
            opacity: 1,
            scale: 1,
          },
          exit: {
            opacity: 0,
            scale: 0.9,
          },
        }}
        className="bg-white rounded shadow-xl md:w-1/3 p-10 relative z-10"
      >
        {isLoading && (
          <div className="flex items-center justify-center">
            <Spinner />
          </div>
        )}
        {!isLoading && noSavedContent && (
          <div className="">
            <h2 className="text-4xl font-bold text-center appTitleItem mb-4">
              No content to share
            </h2>
            <p className="text-center text-sm">
              Make some edits to onepage to save your changes and share them...
            </p>
          </div>
        )}

        {!isLoading && !noSavedContent && (
          <>
            <h2 className="text-5xl font-bold text-center appTitleItem">
              Your Share URL
            </h2>
            <p className="text-center text-sm mt-3">
              Copy this URL, and anyone with the link will be able to see your
              edited content on this onepager. Other people will not be able to
              edit the content.
            </p>
            <div className="mt-5">
              {shareUrl && (
                <input
                  readOnly
                  value={shareUrl}
                  className="text-sm  font-medium border-2 border-black shadow-inner mb-2   block w-full p-5"
                  type="text"
                  placeholder="Share url..."
                />
              )}
              {!shareUrl && (
                <div className="text-center bg-gray-100 py-2 font-medium">
                  Loading..
                </div>
              )}
            </div>
            <div className="flex justify-center">
              <button
                onClick={() => {
                  copyToClipboard(shareUrl)
                }}
                className="bg-black mt-3 rounded p-3 text-white font-bold"
              >
                Copy URL To Clipboard
              </button>
            </div>
          </>
        )}

        <div className="text-center mt-3 text-yellow-700 font-medium">
          {clipboardState.error ? (
            <div>Unable to copy value: {clipboardState.error.message}</div>
          ) : (
            clipboardState.value && <div>Copied URL!</div>
          )}
        </div>
      </motion.div>
    </div>
  )
}

export default ShareModal
